
import ElaineDunphy from './img/testimonial_portraits/Elaine_Dunphy.png';
import InbalShorPadowicz from './img/testimonial_portraits/Inbal_Padowicz.png';
import KellieChambers from './img/testimonial_portraits/Kellie_Chambers.png';
import LaurieBass from './img/testimonial_portraits/Laurie_Bass.png';
import LeslieSwitzer from './img/testimonial_portraits/Leslie_Switzer.png';
import LucyPage from './img/testimonial_portraits/Lucy_Page.png';
import MariaWhitley from './img/testimonial_portraits/Maria_Whitley.png';
import MelissaDiaz from './img/testimonial_portraits/Melissa_Diaz.png';
import SherrelSavage from './img/testimonial_portraits/Sherrel_Savage.png';
import TaniaBownes from './img/testimonial_portraits/Tania_Bownes.png';
import ThomasRomano from './img/testimonial_portraits/Thomas_Romano.png';
import JaneMeldrum from './img/testimonial_portraits/Jane_Meldrum.png';

const testimonials = {
  kellieChambers: {
    name: '— Kellie Chambers',
    quote: 'Nia helped me reconnect to my body when I was at a point in life where I felt stiff, old, and disconnected with my spirit. From that first class experience, I was hooked, it was like coming home to my body and the girl inside who was always there waiting for me. Teaching was a natural extension of my love affair with Nia.',
    beltLevel: '3rd Gen Trainer',
    location: 'Oregon USA',
    photo: KellieChambers,
    alt: 'Kellie Chambers - Nia',
  },
  melissaDiaz: {
    name: '— Melissa Diaz',
    quote: 'After a car accident, I was going to a chiropractor, a physical therapist and had just started Nia. I always felt better after doing Nia. I truly believe Nia helped me heal both physically and emotionally... I just knew I needed to share with others the healing power, the aliveness, and the Joy Nia has brought and continues to bring me.',
    beltLevel: 'Black Belt',
    location: 'California, USA',
    photo: MelissaDiaz,
    alt: 'Melissa Diaz - Nia',
  },
  taniaBownes: {
    name: '— Tania Bownes',
    quote: 'Nia brought all my passions together. My love of touch. My passion to move and dance. My love of self healing. My passion to connect and share in community. My deep love of play. And my need for silent inner contemplation. I have been teaching for 17 years. I never stop learning.',
    beltLevel: 'Black Belt',
    location: 'Cape Town, South Africa',
    photo: TaniaBownes,
    alt: 'Tania Bownes - Nia',
  },
  sherrelSavage: {
    name: '— Sherrell Savage',
    quote: 'I became a Nia teacher to share the joy, community & healing I\'ve experienced with other women who look like me. I also wanted to share with other women of faith that you can have an experience with whoever you see God as when you step on the dance floor.',
    beltLevel: 'White Belt',
    location: 'Maryland, USA',
    photo: SherrelSavage,
    alt: 'Sherrel Savage - Nia',
  },
  thomasRomano: {
    name: '— Thomas Romano',
    quote: 'I love to witness people getting to move and learning to sense new parts of their body in space and in stillness.',
    beltLevel: 'Brown Belt',
    location: 'Lyon, France',
    photo: ThomasRomano,
    alt: 'Thomas Romano - Nia',
  },
  mariaWhitley: {
    name: '— Maria Whitley',
    quote: 'The thing that I love most about teaching is creating a safe space where the students feel like they are being held and discover their own love of being in and moving their bodies.',
    beltLevel: 'First Degree Black Belt',
    location: 'Kentucky, USA',
    photo: MariaWhitley,
    alt: 'Maria Whitley - Nia',
  },
  laurieBass: {
    name: '— Laurie Bass',
    quote: 'My favorite thing about being a Nia teacher + trainer is witnessing people reclaim their health, their bodies, joy and power moving the Nia way. Seeing the spark + life force SHINE. I love weaving the magic of community connection. I love the magic of our teacher community, getting to meet, move, connect and be in relationship with so many AMAZING people locally and globally.',
    beltLevel: 'Nia Faculty Trainer',
    location: 'Oregon, USA',
    photo: LaurieBass,
    alt: 'Laurie Bass - Nia',
  },
  lucyPage: {
    name: '— Lucy Page',
    quote: 'My favorite thing about teaching Nia is witnessing students as they connect to their bodies in a loving and meaningful way. The variety of music and ability to tailor each class to “your body’s way” allows access to a meaningful practice for every body. To me, that is what allows each person to find their path in the practice.',
    beltLevel: 'Black Belt',
    location: 'Washington, USA',
    photo: LucyPage,
    alt: 'Lucy Page - Nia',
  },
  elaineMarieDunphy: {
    name: '— Elaine Marie Dunphy',
    quote: 'From the moment I first stepped in, literally, it felt like coming home to my body! It changed, and continues to change my life, daily!',
    beltLevel: 'Blue Belt',
    location: 'Newfoundland, Canada',
    photo: ElaineDunphy,
    alt: 'Elaine Marie Dunphy - Nia',
  },
  leslieSwitzer: {
    name: '— Leslie Switzer',
    quote: 'I LOVE to dance! The opportunity to share the joy of dance as an adult with others was the perfect fit for me. I stepped in to a White Belt in 2000...It was a pivotal moment in my life and I am very grateful.',
    beltLevel: 'Brown Belt',
    location: 'Ontario, Canada',
    photo: LeslieSwitzer,
    alt: 'Leslie Switzer - Nia',
  },
  inbalShorPadowicz: {
    name: '— Inbal Shor Padowicz',
    quote: 'In my first Nia experience I felt that Nia is something that should be spread all over, and that every body in the world should know it exists.',
    beltLevel: 'Blue Belt',
    location: 'Tel Aviv, Israel',
    photo: InbalShorPadowicz,
    alt: 'Inbal Shor Padowicz - Nia',
  },
  janeMeldrum: {
    name: '— Jane Meldrum',
    quote: 'From my first class... I was amazed at how Nia works for all different age groups. I never forget walking past a room with about 70 people dancing in it and I thought that looks like fun. I must join them! From my first class Nia felt so good for my body & mind.I now teach Nia to the children in my Montessori classroom that are age 3 through 6. The children love it.',
    beltLevel: 'White Belt',
    location: 'Pending',
    photo: JaneMeldrum,
    alt: 'Jane Meldrum - Nia',
  },
};

export default testimonials;
